<template>
  <div>
    <!-- Modal Component -->
    <b-modal v-model="loginModal"
             :header-bg-variant="loginModalState"
             header-text-variant="light"
             class="mt-3"
             :modal-footer="false"
             :no-close-on-esc="true"
             :no-close-on-backdrop="true"
             :hide-header-close="true"
             centered :title="titleMsg">

      <form @submit="handleSubmit">
        <b-form-input type="text"
                      placeholder="Όνομα χρήστη"
                      v-model= "username" required></b-form-input>
        <br/>
        <b-form-input type="password"
                      placeholder="Κωδικός πρόσβασης"
                      v-model= "password" required></b-form-input>
        <br/>

        <b-btn type="submit" variant="outline-primary" block size="md" class="float-right mt-3">Είσοδος</b-btn>

      </form>
      <div slot="modal-footer"><b-link href="https://submit.eudoxus.gr/" target="_blank"><i><small>Υπενθύμιση κωδικού πρόσβασης</small></i></b-link></div>
    </b-modal>
  </div>
</template>

<script>

  import NavBar from '../NavBar.vue';
  import requests, {GlobalEudoxusBus} from '../../js/DistributionRequestService';

  export default {
    name: "loginComponent",
    data() {
      return {
        username: '',
        password: '',
        loginModal: false,
        distributionPointDto: '',
        distributionValidDates: '',
        loginModalState: 'primary',
        titleMsg: 'Παρακαλώ εισάγετε τα στοιχεία σας'
      }
    },
    methods: {
      handleSubmit() {
        this.titleMsg = 'Παρακαλώ εισάγετε τα στοιχεία σας';
        this.loginModalState = 'primary';
        requests.login(this.username, this.password, this.hideModal, this.loginFailed);
      },
      showModal() {
        // this.$refs.loginModal.show();
        this.loginModal = true;
      },
      hideModal() {
        // this.$refs.loginModal.hide();
        this.loginModal = false;
        requests.getLoggedOnUser(this.getValidDates);
      },
      getValidDates() {
        GlobalEudoxusBus.$emit('distributionTabsLayoutSetup', requests.getDistributionType());
        requests.getDistributionValidDates();
      },
      loginFailed() {
        this.loginModalState = 'danger';
        this.titleMsg = 'Λάθος όνομα χρήστη ή κωδικός πρόσβασης';
      }
    },
    components: {
      'navBar': NavBar
    },
    mounted: function () {
      // this.$refs.loginModal.hide();
      this.loginModal = false;
    },
    created() {
      GlobalEudoxusBus.$on('distributionPointDto', distributionPointDto => {
        this.$emit('distributionPointDto', distributionPointDto);
      });
      GlobalEudoxusBus.$on('distributionValidDatesDto', distributionValidDatesDto => {
        this.$emit('distributionValidDatesDto', distributionValidDatesDto);
      });

      GlobalEudoxusBus.$on('toggleLoginModal', flag => {
        if (flag)
          // this.$refs.loginModal.show();
          this.loginModal = true;
        else
          // this.$refs.loginModal.hide();
          this.loginModal = false;
      });
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/LoginModalComponent/LoginComponent.vue